import axios from 'axios';
import i18n from 'i18next';
import { JAPANESE } from '../constants/language';
import { CUSTOMIZATION_URL } from '../constants/api';

export const loadI18nCustomization = (accountId) => {
    // ATTUNED-2963

    return () => {
        const URL = `${ process.env.API_URL }${ CUSTOMIZATION_URL
            .replace('{accountId}', accountId)
            .replace('{customizationType}', 'LOCALE_SURVEY')
            .replace('{customizationKey}', 'ja.json')
        }`;

        return axios.get(URL).then(({ value }) => {
            return axios.get(value);
        }).then((res) => {
            i18n.addResourceBundle(JAPANESE, 'translation', {
                ...res
            }, true, true);
        }).catch(console.debug);
    };
};
